import { css } from "@emotion/core"
import React from "react"

import { mq, fontSize } from "../mixins"

import "./location.scss"

const Locations = props => {
  const locationListContainer = css`
    padding-bottom: 56px;
    h1,
    h2,
    h3,
    h4,
    h5,
    p,
    a {
      /* font-family: "Saira Condensed", sans-serif;
      font-weight: 700; */
      text-align: center;
      /* line-height: 1.3; */
    }
    ${mq("desktop")} {
      padding-bottom: 96px;
    }
  `
  const locationListContainerH2 = css`
    text-transform: uppercase;
    text-align: center;
    color: ${props.color_theme === "light" ? "#000;" : "#fff"};
    /* ${fontSize(40, 60)} */
  `

  const locationListUl = css`
    ${mq("smTablet")} {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 70%;
      max-width: 1050px;
      margin: 0 auto;
    }
    ${mq("desktop")} {
      width: 100%;
      max-width: 100%;
    }
  `

  const locationListUlLi = css`
    padding-top: 32px;
    ${mq("smTablet")} {
      width: 44%;
      padding-top: 8%;
      flex: none;
      &:nth-of-type(even) {
        margin-left: auto;
        margin-right: 0;
        width: auto;
      }
    }
    ${mq("desktop")} {
      width: 23%;
      margin-left: 9%;
      &:nth-of-type(1) {
        padding-top: 48px;
      }
      &:nth-of-type(2) {
        padding-top: 48px;
      }
      &:nth-of-type(3) {
        padding-top: 48px;
      }
      &:nth-of-type(even) {
        margin-left: 9%;
        margin-right: 0;
        width: 23%;
      }
    }
  `

  const locationListUlLiHeader = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${mq("smTablet")} {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      /* width: 65%; */

      img {
        position: absolute;
        left: -35px;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;
      }
    }
  `

  const locationListUlLiHeaderCopy = css`
    & > * {
      display: inline-block;
      border-bottom: 2px solid rgba(158, 158, 158, 1);
    }
    & > * {
      text-transform: uppercase;
      text-align: left;
      color: ${props.color_theme === "light" ? "#000;" : "#fff"};
    }
  `

  const locationListUlLiContent = css`
    padding-top: 12px;
    & > * {
      text-align: center;
      text-transform: uppercase;
      color: ${props.color_theme === "light" ? "#000;" : "rgba(158,158,158,1)"};
    }
    ${mq("smTablet")} {
      /* width: 65%; */
      & > * {
        text-align: left;
      }
    }
  `
  return (
    <div className="locationList">
      <div className="locationList__container" css={locationListContainer}>
        <h2 className="headline" css={locationListContainerH2}>
          {props.headline}
        </h2>
        <div className="locationList__ul" css={locationListUl}>
          {props.modular_blocks.map((item, key) => {
            return (
              <div
                className="locationList__ul__li"
                key={`${key}-locationList__ul__li`}
                css={locationListUlLi}
              >
                <div
                  className="locationList__ul__li--header"
                  css={locationListUlLiHeader}
                >
                  <img
                    src={props.list_image.url}
                    alt="crown"
                    className="locationList__list__item--header__img"
                  />
                  <div
                    className="locationList__ul__li--header__copy"
                    css={locationListUlLiHeaderCopy}
                    dangerouslySetInnerHTML={{
                      __html: item.location_component.location_headline,
                    }}
                  ></div>
                </div>
                <div
                  className="locationList__ul__li--content"
                  css={locationListUlLiContent}
                  dangerouslySetInnerHTML={{
                    __html: item.location_component.location_content,
                  }}
                ></div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Locations
